module.exports = __webpack_public_path__ + "img/btn_order_all_close.e06adcef.svg";